import * as React from 'react'

import { StyledFormTitle } from './FormTitle.glamorous'

export const FormTitle: React.SFC = ({ children }) => {
  return (
    <StyledFormTitle>
      {children}
    </StyledFormTitle>
  )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/LoginForm/components/FormTitle/FormTitle.tsx